export default __webpack_public_path__ + "static/media/bg02.28162938.png";